<div class="container-fluid">
    <div class="d-flex justify-content-center"></div>
    <div class="row d-flex justify-content-center mx-3 my-2">

    </div>
    <div class="row pt-2 text-white">
        <div class="col mx-4 border rounded Dashboard-tab view-request-col">
            <form #sendApprovalForm="ngForm">
                <div class="row mx-2 border-bottom mt-3 pb-3">
                    <div class="row d-flex align-items-center ml-0 gap-3 ct_drop_input_250123">
                        <p-dropdown class="ct_custom_drop_white ct_input_dark_text_14 ct_chev_icon_dark230 " ngModel
                            [options]="AllCategory" optionLabel="catName" optionValue="id" name="DEMode"
                            #DEMode="ngModel" [(ngModel)]="selectedCategory" (onChange)="getEntry()"></p-dropdown>
                        <div class="col-md-6" *ngIf="modeShow">
                            <p-dropdown class="ct_input_white_bg13 ct_select_2_drop_white ct_input_dark_text_145"
                                [options]="Modes" defaultLabel="Select Data Points" [(ngModel)]="selectMode"
                                optionLabel="modeType" optionValue="id" name="datapoint"
                                (onChange)="getModesEntry()"></p-dropdown>
                        </div>
                        <div class=" ml-2 ct_calander_600_height_38">
                            <p-calendar class="ct_calender_input_1234   ct_calander_input_box_white_bg20" ngModel
                                name="year" year [(ngModel)]="year" styleClass="pcalender" view="year" dateFormat="yy"
                                inputId="yearpicker" [showIcon]="true" (ngModelChange)="FilterByYear()"></p-calendar>
                        </div>
                    </div>

                    <div class="col text-right pt-0 d-flex justify-content-end pr-0 gap-3">
                        <!-- <span class="mr-2 countrequest"></span> -->

                        <p-dropdown
                            class="ct_input_white_bg13 ct_select_2_drop_white ct_input_dark_text_145 mr-3 et_dropdown_li_left_w_g_b"
                            [options]="buttonOptions" [(ngModel)]="action" [ngModelOptions]="{standalone: true}"
                            optionLabel="label" optionValue="value" (onChange)="changeHandler()"></p-dropdown>

                        <button (click)="sendAction(this.action)"
                            class="btn btn-sm SendforApproval-button text-white mb-0 mr-2"
                            style="border:1px solid  #88AD47;">
                            Submit
                        </button>
                    </div>
                </div>

                <div class="p-0 m-0 view-request-div table-responive cd_requst__static12">
                    <ng-container *ngIf="loading; else tableData">
                        <div class="d-flex justify-content-center my-4 etd_loader_h">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #tableData>
                        <p-table class="ct_bottom_table_tr et_table_spacing_12 ct_chev_icon_dark230" #dt
                            [(selection)]="selectedEntry" [scrollable]="true" [globalFilterFields]="['catName']"
                            dataKey="id" [rowsPerPageOptions]="[10, 25, 50, 100, 200, 500]" [rowHover]="true"
                            [globalFilterFields]="['catName', 'subcatName', 'year', 'month', 'readingValue', 'unit', 'status']"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            [value]="dataEntriesPending" [paginator]="true" [rows]="rows" editMode="row"
                            [showCurrentPageReport]="true" (onPage)="onPageChange($event)"
                            [lazy]="selectedCategory === 8" [totalRecords]="totalRecords">
                            <ng-template pTemplate="caption">
                                <div class="flex justify-content-between">
                                    <p-button [outlined]="true" icon="pi pi-filter-slash" label="Clear"
                                        (onClick)="clear34(dt)">
                                    </p-button>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>
                                        <input class="ct_input_checkbox_1234 d-flex" type="checkbox"
                                            [checked]="allSelected" (change)="toggleSelectAll($event)" />
                                    </th>
                                    <ng-container *ngFor="let col of columns">

                                        <!-- If this column is array -->
                                        <ng-container *ngIf="col.isArray; else normalHeader">
                                            <ng-container
                                                *ngFor="let item of dataEntriesPending[0][col.field]; let i = index">
                                                <th> {{ item.water_withdrawl || item.water_discharge }} (%) </th>
                                                <th *ngIf="col.xtra"> {{ col.xtra }} </th>
                                            </ng-container>
                                        </ng-container>

                                        <!-- Normal header -->
                                        <ng-template #normalHeader>
                                            <th class="ct_filter_icon_hove_active_1234"> {{ col.header }}
                                                <i *ngIf="col.filter" class="pi"
                                                    [ngClass]="columnFilterValues[col.field] ? 'pi-filter-fill' : 'pi-filter'"
                                                    (click)="openDirectFilter($event, drop)"
                                                    style="cursor:pointer; margin-left:6px"></i>
                                                <p-dropdown #drop [(ngModel)]="columnFilterValues[col.field]"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    [options]="col.filterOptions" optionLabel="name"
                                                    [optionValue]="col.filterField" [filter]="true" filterBy="name"
                                                    appendTo="body" placeholder="Any"
                                                    class="ct_select_op_input hidden-multiselect"
                                                    (onChange)="applyFilter($event.value, col.field, dt)">
                                                </p-dropdown>
                                            </th>
                                        </ng-template>
                                    </ng-container>
                                    <th>Year</th>
                                    <!-- <th>Month</th> -->
                                    <th>Status</th>
                                    <th>Emission (tCO2e)</th>
                                    <th>User</th>
                                    <th>Action</th>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-row let-de let-editing="editing" let-ri="rowIndex">
                                <tr>
                                    <td>
                                        <p-tableCheckbox [value]="de"></p-tableCheckbox>
                                        <label class="sendLable" *ngIf="
                                                      de.sendForApproval === true &&
                                                      loginInfo.role === Preparer &&
                                                      de.status === Pending
                                                  ">Sent for Approval</label>
                                    </td>
                                    <!-- If it's an array -->
                                    <ng-container *ngFor="let col of columns">
                                        <ng-container *ngIf="col.isArray; else normalCell">
                                            <ng-container *ngFor="let item of row[col.field]; let i = index">
                                                <td>
                                                    {{ item.kilolitres || item.withthtreatment }}
                                                </td>
                                                <td *ngIf="col.xtra"> {{item.treated_water }} </td>
                                            </ng-container>
                                        </ng-container>

                                        <ng-template #normalCell>
                                            <td>
                                                <ng-container [ngSwitch]="col.field">
                                                    <ng-container *ngSwitchCase="'productcodes'">
                                                        {{ row.product_code_name }} {{ row.productCode }}
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="'combineVehicle'">
                                                        {{ row.category_name }} - {{ row.type }}
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="'franchise_spaceLease'">
                                                        {{ row.franchise_space }} {{ row.unit }}
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>
                                                        {{ row[col.field] }}
                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                        </ng-template>

                                    </ng-container>


                                    <td>{{ row.year }}</td>
                                    <!-- <td>{{ row.month }}</td> -->
                                    <td>
                                        <div class="d-flex text-white justify-content-center">
                                            <span [ngClass]="{
                                                          Rejected:
                                                              de.status === Rejected,
                                                          Pending: de.status === Pending,
                                                          Approved: de.status === Approved
                                                      }">{{ de.status }}</span>
                                            <!-- <span *ngIf="de.status === Rejected && loginInfo.role !== Approver"
                                                      class="pt-2 pl-1"><i class="pi pi-comment pointer"
                                                          (mouseover)="op.toggle($event)"
                                                          (mouseleave)="op.toggle($event)"></i></span> -->
                                        </div>

                                        <p-overlayPanel #op>
                                            <p>{{ de.Reason }}</p>
                                        </p-overlayPanel>
                                    </td>
                                    <td>{{ row.emission }}</td>
                                    <td>{{ row.user_name }}</td>
                                    <td>


                                        <div *ngIf="
                                              de.status === Pending
                                           " class="d-flex font-pera text-center pl-3 pt-0">
                                            <button type="button"
                                                class="btn btn-dark margin ct_view_request_action_btn_green"
                                                data-bs-toggle="modal" data-bs-target="#viewModal"
                                                ngbTooltip="Accept / Reject" (click)="onUpdateUserStatus(de)">
                                                <i class="fa fa-eject" aria-hidden="true"></i>
                                            </button>

                                            <p-dialog header="Header" [(visible)]="visible" [style]="{width: '50vw'}">
                                                <ng-template pTemplate="header">
                                                    <span class="text-xl font-bold mx-auto">Reason</span>
                                                </ng-template>

                                                <label class="py-2">Please enter Reason for reject
                                                    entry</label>
                                                <div class="pl-5">
                                                    <textarea name="reason" rows="5" class="ct_textarea_full"
                                                        pInputTextarea [(ngModel)]="de.reason" #inputreason="ngModel"
                                                        required></textarea>
                                                    <p class="text-danger mb-0"
                                                        *ngIf="inputreason.errors?.['required']">
                                                        reason is required
                                                    </p>
                                                </div>


                                            </p-dialog>
                                        </div>
                                        <label class="sendLable" *ngIf="
                                                      de.sendForApproval === true &&
                                                      loginInfo.role === Preparer &&
                                                      de.status === Pending
                                                  ">Sent for Approval</label>
                                    </td>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td [attr.colspan]="columns.length + 6" class="text-center py-4">
                                        No data available
                                    </td>
                                </tr>
                            </ng-template>
                            <!-- <ng-container *ngIf="loading === true">
                                  <div class="d-flex justify-content-center">
                                      <div class="spinner-border" role="status">
                                        <span class="sr-only">Loading...</span>
                                      </div>
                                    </div>
                              </ng-container> -->
                        </p-table>
                    </ng-template>
                </div>
            </form>
        </div>
    </div>
</div>


<div class="modal fade show" id="myModal" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true"
    [ngStyle]="{'display':display}">
    <div class="modal-dialog ct_modal_center_120">
        <div class="modal-content ct_modal_main_div140 ">
            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">Update Status</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closePopup"
                    (click)="onClose2()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body">
                <p>Would you like to accept or reject?</p>
                <button type="button" class="btn btn-primary text-white" id="acceptBtn"
                    (click)="AcceptSingleEntry()">Approve</button>
                <button type="button" class="btn btn-danger ml-2 text-white" id="rejectBtn"
                    (click)="RejectSingleEntry()">Reject</button>
            </div>

            <!-- Modal Footer -->

        </div>
    </div>
</div>
<div class="modal fade show" id="myModal" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true"
    [ngStyle]="{'display':display2}">
    <div class="modal-dialog ct_modal_center_120">
        <div class="modal-content ct_modal_main_div140 ">
            <!-- Modal Header -->
            <div class="modal-header">
                <h5 class="modal-title text-danger font-weight-bold">Delete Confirmation</h5>
                <button type="button" class="close" aria-label="Close" (click)="onClose2()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <p class="mb-4">Are you sure you want to delete selected approved items?</p>
                <button type="button" class="btn btn-outline-secondary" (click)="onClose2()">Cancel</button>
                <button type="button" class="btn btn-danger ml-2" (click)="sendEntires(this.action)">Delete</button>
            </div>

            <!-- Modal Footer -->

        </div>
    </div>
</div>